import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreData } from 'src/app/utils/store_data';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ComplainService {

  private http: HttpClient = inject(HttpClient);
  private store: StoreData = inject(StoreData);

  getComplainList(status: string, startDate: string, endDate: string, page: number, pageSize: number): Observable<any> {

    let url = environment.baseUrl + 'api/drapp/complain/list?status=' + status + '&page=' + page + '&pageSize=' + pageSize;
    if (startDate && endDate) {
      url = environment.baseUrl + 'api/drapp/complain/list?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate + '&page=' + page + '&pageSize=' + pageSize;
    }

    const httpOptions = this.getHeaders();
    return this.http.get<any>(url, httpOptions);
  }

  createComplain(title: string, description: string): Observable<any> {
    const httpOptions = this.getHeaders();
    return this.http.post<any>(environment.baseUrl + 'api/drapp/complain/create?title=' + title + '&description=' + description, null, httpOptions);
  }

  // GET: Fetch target complaint metrics along with total timeline logs
  getComplainDetail(complainId: number): Observable<any> {
    const httpOptions = this.getHeaders();
    return this.http.get<any>(environment.baseUrl + 'api/drapp/complain/detail?complainId=' + complainId, httpOptions);
  }

  // POST: Submits structured dialogue logs to your server context streams
  createChatMessage(
    complainId: number,
    body: string,
    messageType: string,
    messageId: number
  ): Observable<any> {
    const httpOptions = this.getHeaders();
    return this.http.post<any>(environment.baseUrl + 'api/drapp/complain/message/create?complainId=' + complainId + '&body=' + body + '&messageType=' + messageType + '&messageId=' + messageId, null, httpOptions);
  }

  updateComplainStatus(complainId: number, status: string) {
    const httpOptions = this.getHeaders();
    return this.http.post<any>(environment.baseUrl + 'api/drapp/complain/update/status?complainId=' + complainId + '&status=' + status, null, httpOptions);
  }

  getDownloadFile(fileName: any, status: any, startDate: any, endDate: any): Observable<any> {

    const headers = {
      'Accept': 'application/json',
      'Authorization': this.store.getAuth(),
    }

    let url = 'api/drapp/complain/download?fileName=' + fileName + '&status=' + status;

    if (startDate && endDate) {
      url += '&startDate=' + startDate + '&endDate=' + endDate;
    }

    return this.http.get(environment.baseUrl + url, { headers, withCredentials: true, responseType: 'text' })

  }

  getHeaders() {
    var result = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': this.store.getAuth(),
      }),
      withCredentials: true
    }
    return result;
  }

}
